import React, { useState } from "react";
import { fmtKc } from "../lib/format";

// Co se s řádkem při importu stalo (server: akce v přehledu dávky).
const AKCE = {
  NOVA_CENIK: ["Nová · do ceníku", "bg-ink text-white"],
  NOVA: ["Nová · jen v nabídce", "bg-white text-sec border border-line-strong"],
  OPRAVA_CENY: ["Oprava ceny v ceníku", "bg-[#fdf3e2] text-[#8a5300]"],
  JEN_NABIDKA: ["Cena jen pro nabídku", "bg-[#e8f0fb] text-[#2f6fd0]"],
  CENIK_POUZITA: ["Cena z ceníku", "bg-success-bg text-success"],
  Z_CENIKU: ["Z ceníku", "bg-success-bg text-success"],
};
const STITEK = "inline-flex items-center h-5 px-2 rounded-pill text-[9.5px] tracking-[0.07em] uppercase font-700 whitespace-nowrap";
const pct = (n) => `${String(Math.round(n * 10) / 10).replace(".", ",")} %`;

/** Přehled všech importovaných položek se štítky — po importu i později v historii
    importů nabídky (pojistka, když se práce přeruší). */
export default function PrehledImportu({ radky = [], bezCeniku = false }) {
  const [filtr, setFiltr] = useState("vse");
  const filtry = [
    ["vse", "Vše", () => true],
    ["nove", "Nové", (r) => r.akce === "NOVA_CENIK" || r.akce === "NOVA"],
    ["oprava", "Oprava ceny", (r) => r.akce === "OPRAVA_CENY"],
    ["hlavni", "Hlavní zařízení", (r) => r.hlavni],
    ["bez", "Bez marže", (r) => r.doplnit_marzi],
  ].filter(([k, , fn]) => k === "vse" || radky.some(fn)).filter(([k]) => !bezCeniku || k !== "bez");
  const fn = (filtry.find(([k]) => k === filtr) || filtry[0])[2];
  const vidim = radky.filter(fn);

  return (
    <div className="flex flex-col gap-2.5" data-testid="prehled-importu">
      <div className="flex gap-2 overflow-x-auto -mx-4 px-4 md:mx-0 md:px-0 md:flex-wrap pb-0.5">
        {filtry.map(([k, label, f]) => (
          <button key={k} type="button" onClick={() => setFiltr(k)} data-testid={`prehled-filtr-${k}`}
            className={`tap md:min-h-0 shrink-0 inline-flex items-center gap-1.5 h-9 md:h-8 px-3 rounded-pill border t-meta font-600 ${
              filtr === k ? "bg-ink text-white border-ink" : "bg-white text-sec border-line-strong"}`}>
            {label}<span className="amount opacity-60 font-700">{radky.filter(f).length}</span>
          </button>
        ))}
      </div>
      <div className="bg-white border border-line rounded-[12px] overflow-hidden">
        <div className="hidden md:grid grid-cols-[minmax(0,1fr)_64px_96px_64px_96px_110px] gap-2.5 px-3.5 py-2 bg-inputbg border-b border-line label-up text-sec-3">
          <span>Položka</span><span className="text-right">Množ.</span>
          <span className="text-right">{bezCeniku ? "" : "Nákup / ks"}</span><span className="text-right">{bezCeniku ? "" : "Marže"}</span>
          <span className="text-right">Prodej / ks</span><span className="text-right">Celkem</span>
        </div>
        <div className="md:max-h-[360px] md:overflow-y-auto">
          {vidim.map((r, i) => {
            const [akceText, akceStyl] = AKCE[r.akce] || [null, ""];
            const prodej = r.prodej_jednotka ?? 0;
            const stitky = (
              <span className="flex flex-wrap items-center gap-1.5">
                {akceText && <span className={`${STITEK} ${akceStyl}`}>{akceText}</span>}
                {r.hlavni && <span className={`${STITEK} border border-accent text-accent-hover`}>Hlavní zařízení</span>}
                {r.doplnit_marzi && !bezCeniku && <span className={`${STITEK} bg-[#fff1e8] text-accent-hover`}>Bez marže</span>}
                {r.akce === "OPRAVA_CENY" && r.puvodni_cena != null && <span className="t-meta text-sec-3 amount">bylo {fmtKc(r.puvodni_cena)} Kč</span>}
                {r.akce === "JEN_NABIDKA" && r.puvodni_cena != null && <span className="t-meta text-sec-3 amount">v ceníku {fmtKc(r.puvodni_cena)} Kč</span>}
              </span>
            );
            return (
              <div key={r.radek_id || i} className="border-b border-line-soft last:border-b-0" data-testid={`prehled-radek-${i}`}>
                <div className="hidden md:grid grid-cols-[minmax(0,1fr)_64px_96px_64px_96px_110px] gap-2.5 px-3.5 py-2.5 items-start">
                  <span className="min-w-0 flex flex-col gap-1"><span className="t-telo font-600 text-ink truncate" title={r.nazev}>{r.nazev}</span>{stitky}</span>
                  <span className="amount text-right text-sec">{r.mnozstvi ?? ""} {r.mj || ""}</span>
                  <span className="amount text-right text-sec">{bezCeniku || r.cena_nakup == null ? "" : `${fmtKc(r.cena_nakup)} Kč`}</span>
                  <span className="amount text-right text-sec">{bezCeniku || r.marze_pct == null ? "" : pct(r.marze_pct)}</span>
                  <span className="amount text-right">{fmtKc(prodej)} Kč</span>
                  <span className="amount text-right font-700">{fmtKc(prodej * (r.mnozstvi || 0))} Kč</span>
                </div>
                <div className="md:hidden px-3.5 py-3 flex flex-col gap-1.5">
                  <span className="t-telo font-600 text-ink">{r.nazev}</span>
                  {stitky}
                  <span className="flex justify-between t-meta text-sec-3 amount">
                    <span>{r.mnozstvi ?? ""} {r.mj || ""}{!bezCeniku && r.marze_pct != null ? ` · marže ${pct(r.marze_pct)}` : ""}</span>
                    <b className="text-ink">{fmtKc(prodej * (r.mnozstvi || 0))} Kč</b>
                  </span>
                </div>
              </div>
            );
          })}
          {!vidim.length && <div className="p-3.5 t-meta text-sec-3">Žádné položky.</div>}
        </div>
      </div>
    </div>
  );
}
